import { TrackingDataQuery, trackingDataApis } from '@apis/dashboard/trackingDataApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useTrackingDataList = createUseQuery(
  (query: TrackingDataQuery) => ['/dashboard/tracking-data/', query],
  (query) => () =>
    trackingDataApis
      .get('/dashboard/tracking-data/', {
        query,
      })
      .then((r) => r[200]!),
);

export const TRACKING_DATA_PAGE_SIZE = 10;
